export default __webpack_public_path__ + "static/image_les_suites_s-ee325dc80af2ccd2d32050f0bc46ac26.jpg";